import React from "react";

const Crosole = ({ theme }) => {
  return (
    <div
      className="py-5"
      style={{
        backgroundColor: "black",
        color: "white",
        height: "500px", // Height is reduced here (or any other value)
      }}
    >
      <div className="container d-flex align-items-center">
        <div className="row align-items-center">
          {/* Image Section */}
          <div
            className="col-12 col-md-6 order-md-2 text-center"
            data-aos="zoom-in"
            data-aos-duration="1500"
          >
            <img
              src="bannerimage/img.png"
              alt=""
              className="img-fluid shadow-lg"
              style={{ maxHeight: "350px" }} // Reduced maxHeight of the image
            />
          </div>

          {/* Text Section */}
          <div
            className="col-12 col-md-6 order-md-1 text-center text-md-start"
            style={{ paddingRight: "2rem" }}
          >
            <p
              data-aos="fade-up"
              className="text-primary fs-4 fw-semibold font-serif"
              style={{ color: "white" }} // टेक्स्ट का रंग सफेद रखें
            >
              Effortless
            </p>
            <h1
              data-aos="fade-up"
              data-aos-delay="750"
              className="display-4 fw-bold font-serif"
            >
              A trusted partner in
            </h1>
            <p data-aos="fade-up" data-aos-delay="1000" className="fs-5">
              simplifying logistics
            </p>
            <button
              data-aos="fade-up"
              data-aos-duration="1500"
              className="btn btn-primary px-4 py-2 rounded-pill mt-3"
            >
              Join us
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Crosole;
